import React from 'react';
import './Mainloader.css';

const MainLoader = () => {
  return <div className="spinner" />;
};

export default MainLoader;